import { render } from "./itemList_stock.vue?vue&type=template&id=54b42d64"
import script from "./itemList_stock.vue?vue&type=script&lang=js"
export * from "./itemList_stock.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__